import React, { useEffect } from 'react'
import { createContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import ApiService from '../functions/apiService';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const navigate = useNavigate();
    const [user, setUser] = useState(null);
    const [permission, setPermission] = useState([]);
    const [pages, setPages] = useState([]);
    const [pagesName, setPagesName] = useState([]);
    const [is_dn_deparment, setIsDnDeparment] = useState([]);
    const [department, setDepartment] = useState('');

    useEffect(() => {
        if (localStorage.getItem("token") !== null && localStorage.getItem('permission') !== null && localStorage.getItem('pages') !== null) {
            reloadUserData().then((data) => {
                setUser(data.user)
                setPermission(data.permission)
                setPages(data.allowedPages)
                setPagesName(data.PagesNames)
                setIsDnDeparment(data.is_dn_deparment)
                setDepartment(data.department_name)
            })
            setUser(JSON.parse(localStorage.getItem('user')))
            setPermission(JSON.parse(localStorage.getItem('permission')))
            setPages(JSON.parse(localStorage.getItem('pages')))
            setPagesName(JSON.parse(localStorage.getItem('pagesName')))
            setIsDnDeparment(JSON.parse(localStorage.getItem('is_dn_deparment')))
        } else {
            navigate('/')
        }
    }, [])

    return <AuthContext.Provider value={{
        user, setUser, permission, pages, pagesName, is_dn_deparment, department
    }}>
        {children}
    </AuthContext.Provider>
}

export const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('mode');
    localStorage.removeItem('user');
    localStorage.removeItem('permission');
    localStorage.removeItem('pages');
    localStorage.removeItem('pagesName');
    localStorage.removeItem('is_dn_deparment');
    localStorage.removeItem('runcardFilter')
    window.location.href = '/';
}

export const reloadUserData = () => {
    return ApiService.get('/me', {}, 'me').then(({ data }) => {
        localStorage.removeItem('user');
        localStorage.removeItem('permission');
        localStorage.removeItem('pages');
        localStorage.removeItem('pagesName');
        localStorage.setItem("user", JSON.stringify(data.user))
        localStorage.setItem("permission", JSON.stringify(data.permission))
        localStorage.setItem("pages", JSON.stringify(data.allowedPages))
        localStorage.setItem("pagesName", JSON.stringify(data.PagesNames))
        localStorage.setItem("is_dn_deparment", JSON.stringify(data.is_dn_deparment));
        return data
    })
}

export default AuthContext;
